import { Marked } from "marked";
import { asHTML } from "@prismicio/helpers";
import { getLocaleUrl } from "@wbly/common";
import type { RichTextField } from "@prismicio/client";

export function parsePrismicRichText(content: RichTextField, locale: string) {
  const renderer = {
    link(href: string, _: string, text: string) {
      const url = locale ? getLocaleUrl(locale, href) : href;

      return `<a href="${url}" aria-label="${text}">${text}</a>`;
    },
  };

  const marked = new Marked({ renderer });

  return marked.parseInline(asHTML(content)) as string;
}
